export default "__VITE_ASSET__c61d6fce__"